import { useEffect, useState } from 'react';
import routes from 'routes';
import axios from 'axios';

export default function useUserRoutes(selectedOrganization) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const bearerToken = localStorage.getItem('token');
  const [userRoutes, setUserRoutes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserRoutes = async () => {
      try {
        setIsLoading(true);
        let filteredRoutes = [];

        if (bearerToken) {
          const userResponse = await axios.get(`${apiUrl}auth-service/auth/my`, {
            headers: { Authorization: `Bearer ${bearerToken}` },
          });

          const isAdmin = userResponse.data.data?.isAdmin;

          // Wait until a role is selected
          if (!selectedOrganization && !isAdmin) {
            setUserRoutes([]);
            setIsLoading(false);
            return;
          }

          let permissions = [];

          if (isAdmin) {
            // Admin sees all except excluded
            const excludedRoutes = [
              '/authentication/sign-up',
              '/authentication/sign-in',
              '/bookings',
              '/eventOrganization',
              '/events/single-event/:id/view-registrations',
              '/verifyEmail',
            ];
            filteredRoutes = routes.filter(route => {
              if (route.collapse) {
                route.collapse = route.collapse.filter(subRoute =>
                  !excludedRoutes.includes(subRoute.route)
                );
                return route.collapse.length > 0;
              }
              return !excludedRoutes.includes(route.route);
            });
          } else if (selectedOrganization) {
            permissions = selectedOrganization.permissions || [];

            const excludedRoutes = [
              '/permissions',
              '/permissionTypes',
              '/add-venue',
              '/eventOrganizations',
              '/eventOrganizations/edit-eventOrganization/:id',
              '/add-eventOrganization',
              '/venues/edit-venue/:id',
              '/defaultRoles',
            ];

            const filterRoutesByPermissions = (routes, permissions) => {
              return routes
                .map(route => {
                  if (excludedRoutes.includes(route.route)) return null;

                  const hasPermission = permissions.some(permission =>
                    route.permission === permission.slug || route.permission === 'default'
                  );

                  if (route.collapse) {
                    route.collapse = filterRoutesByPermissions(route.collapse, permissions);
                  }

                  return hasPermission || (route.collapse && route.collapse.length > 0) ? route : null;
                })
                .filter(Boolean);
            };

            filteredRoutes = filterRoutesByPermissions(routes, permissions);
          }
        } else {
          // Guest user routes
          filteredRoutes = routes.filter(route =>
            [
              '/authentication/sign-in',
              '/authentication/sign-up',
              '/register/:eventId',
              '/authentication/reset-password',
              '/userRoles/add-userRoles',
              '/verifyEmail',
              '/verifyToken',
            ].includes(route.route)
          );
        }

        setUserRoutes(filteredRoutes);
      } catch (error) {
        console.error('Error fetching user routes:', error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserRoutes();
  }, [bearerToken, selectedOrganization]);

  return { userRoutes, isLoading };
}